/**
 * @ngdoc services
 * @memberof mercury.modules.reports.labour
 * @name LabourFactory
 */
angular.module('mercury.modules.reports.labour')
  .factory('LabourFactory', ["$http", "$q", "$resource", "userinfo", "settings", function($http, $q, $resource, userinfo, settings) {

  /**
   * Get all the budgets between the start and end dates
   *
   * @memberof LabourBudgetAnalysis
   * @param  {String} startTime Start of period to get budgets for
   * @param  {String} endTime end of period to get budgets for
   * @return {Object} promise
   */

  function LabourBudgetAnalysis(start, end, interval) {
    return $resource(settings.mercHost + '/labour/budget-analysis').query({start: start, end: end, interval: interval}).$promise;
  }

  function LabourRosterVsActual(start, end, interval) {
    return $resource(settings.mercHost + '/labour/roster-vs-actual').query({start: start, end: end, interval: interval}).$promise;
  }

  function LabourRoleAnalysis(start, end) {
    return $resource(settings.mercHost + '/labour/role-analysis').query({start: start, end: end}).$promise;
  }

  function LabourCostCentre(start, end, interval) {
    return $resource(settings.mercHost + '/labour/cost-centre').query({start: start, end: end, interval: interval}).$promise;
  }

  return {
    LabourBudgetAnalysis: LabourBudgetAnalysis,
    LabourRosterVsActual: LabourRosterVsActual,
    LabourRoleAnalysis: LabourRoleAnalysis,
    LabourCostCentre: LabourCostCentre
  };

}]);
